export const ADD_FORM = "add_company_form";
